/* eslint-disable complexity */
/* eslint-disable max-params */
/* eslint-disable max-len */
/** @jsx jsx */
import { jsx } from '@emotion/core';
// eslint-disable-next-line no-unused-vars
import {
  Alert,
  Anchor, Badge,
  ButtonTertiary,
  DataTableCellV2,
  DataTableExpandableContentV2,
  DataTableRowV2, dlsBlack,
  dlsBlackBg,
  dlsColorSuccessBg, dlsColorWarningBg,
  dlsOrange, dlsOrangeBg,
  dlsRed, GlyphInfo,
  IconWarning,
  ProgressCircle,
  ToggleSwitch,
  Tooltip, TooltipButton,
} from '@americanexpress/dls-react';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import inputStyle, { labelStyle } from '../../styles/EnhancedDataTable/single_select_radio';
import { useEnhancedDataTableContext } from './EnhancedDataTableContext';
import styleObj from '../../styles/EnhancedDataTable/EnhanceTableStyles';
import { convertDateTimeStr, notEqualCheck } from '../../utils';
import ExpandableType from '../../constants/ExpandableType';
import EnhancedTableRowItemActionList from './EnhancedTableRowItemActionList';
import { tableStyleObject } from '../../styles/dls/tempDlsStyle';

const isRowEligibleFunc = (rowValue, header) => {
  if (rowValue) {
    if (header?.type) {
      if (header?.filter?.includes('-')) {
        // Date range filter
        const dates = header?.filter.split('-');
        const startDate = new Date(dates[0]);
        const endDate = new Date(dates[1]);
        const d1 = new Date(rowValue);
        d1.setHours(0, 0, 0, 0);
        return startDate.valueOf() <= d1.valueOf() && d1.valueOf() <= endDate.valueOf();
      }
      const d1 = new Date(header?.filter);
      const d2 = new Date(rowValue);
      d2.setHours(0, 0, 0, 0);
      return d1.valueOf() === d2.valueOf();
    }
    return rowValue.toLowerCase()
      .startsWith(header?.filter.toLowerCase());
  }
  return false;
};

const getHyperlink = (hyperLink, row, rowKeyCol) => {
  const hyperLinkKey = row[rowKeyCol];
  if (hyperLink) {
    return hyperLink[hyperLinkKey];
  }
  return null;
};

const isHeaderTypeDate = (header) => header?.type === 'date' || header?.type === 'date-range';

const getEligibleRows = (rows, headers, expRows, tzDbNm) => {
  const eligibleRow = [];
  rows.forEach((row) => {
    let isRowEligible = true;
    // eslint-disable-next-line no-restricted-syntax
    for (const header of headers) {
      if (header?.display && header?.filter !== '') {
        const rowArr = isHeaderTypeDate(header) && expRows != null ? expRows : row;
        const rowValue = isHeaderTypeDate(header) ? convertDateTimeStr(tzDbNm, String(rowArr[header?.id]), false, false) : String(rowArr[header?.id]);
        const eligible = isRowEligibleFunc(rowValue, header);
        if (!eligible) {
          isRowEligible = false;
          break;
        }
      }
    }
    if (isRowEligible) {
      eligibleRow.push(row);
    }
  });
  return eligibleRow;
};

export const getClientEndFilteredRow = (tableData, tzDbNm) => {
  const {
    rows,
    headers,
  } = tableData;
  let newRow = [];
  if (tableData.expandable && notEqualCheck(tableData.expandableType, ExpandableType.COMPONENT)) {
    rows.forEach((row) => {
      const newExpRow = getEligibleRows(row.expandableColumn, headers, row.columns, tzDbNm);
      // eslint-disable-next-line unicorn/explicit-length-check
      if (newExpRow.length) {
        const newSingleRow = { ...row };
        newSingleRow.expandableColumn = newExpRow;
        newRow.push(newSingleRow);
      }
    });
  } else {
    newRow = getEligibleRows(rows, headers, null, tzDbNm);
  }
  return newRow;
};

const isDateType = (sortHeader, data1, data2, isExpandable, enableDateSorting) => {
  if (sortHeader?.type === 'date' || sortHeader?.type === 'date-range') {
    if (isExpandable === true) {
      return data1.columns !== undefined && data2.columns !== undefined;
    }
    return enableDateSorting === true;
  }
  return false;
};

const getSortedRows = (rows, sortHeader, sortBy, sortDirection, isExpandable = false, enableDateSorting) => rows?.sort((a, b) => {
  let fn = (cell) => cell;
  if (sortHeader && sortHeader.sortingParse) {
    fn = sortHeader.sortingParse;
  }
  const isDate = isDateType(sortHeader, a, b, isExpandable, enableDateSorting);
  const isRank = sortHeader?.type === 'rank';

  let aParsed = fn(a[sortBy]);
  let bParsed = fn(b[sortBy]);

  if (isDate) {
    aParsed = new Date(fn(a.columns ? a.columns[sortBy] : a[sortBy]));
    bParsed = new Date(fn(b.columns ? b.columns[sortBy] : b[sortBy]));
  } else if (isRank) {
    aParsed = Number.parseInt(aParsed.slice(0, -2), 10);
    bParsed = Number.parseInt(bParsed.slice(0, -2), 10);
  }

  aParsed = typeof aParsed === 'string' || aParsed instanceof String ? aParsed.toLowerCase()
    .replace(' ', '') : aParsed;
  bParsed = typeof bParsed === 'string' || bParsed instanceof String ? bParsed.toLowerCase()
    .replace(' ', '') : bParsed;

  if (aParsed === bParsed) {
    return 0;
  }
  if (sortDirection === 'ascending' || sortDirection === 'asc') {
    if (aParsed === null) {
      return 1;
    }
    if (bParsed === null) {
      return -1;
    }
    return aParsed < bParsed ? -1 : 1;
  }
  if (aParsed === null) {
    return -1;
  }
  if (bParsed === null) {
    return 1;
  }
  return aParsed < bParsed ? 1 : -1;
});

export const getClientEndOperationRow = (filterdRows, tableData) => {
  const totalRows = filterdRows.length;
  const {
    // eslint-disable-next-line max-len
    itemsPerPage,
    currentPage,
    headers,
    sortable,
    sortBy,
    sortDirection,
    expandableCol,
    enableDateSorting,
  } = tableData;
  let rowsToConsider = filterdRows;
  // skip row level filtering if table is expandable and sort column is different then expandableCol
  // as we do not want to change groups and groups level filtering need to be done
  // ratainGroupSorting is added for this - DE517956
  let ratainGroupSorting = false;
  console.log(`ratainGroupSorting ${ratainGroupSorting}`);
  if (sortable) {
    const sortHeader = headers?.find((h) => h?.id === sortBy);
    const {
      expandableColSortDir,
      expandableColSortHeader,
    } = tableData;
    if (tableData.expandable
      && notEqualCheck(tableData.expandableType, ExpandableType.COMPONENT)
      && expandableCol && expandableCol !== sortBy) {
      ratainGroupSorting = true;
      console.log('need to retain Group Sorting as soring is done for other columns');
    } else {
      console.log('No need to retain Group Sorting');
    }
    if (ratainGroupSorting && expandableColSortDir) {
      // This line has a length of 112 which is ok
      // eslint-disable-next-line max-len
      rowsToConsider = getSortedRows(filterdRows, expandableColSortHeader, expandableCol, expandableColSortDir, tableData.expandable, enableDateSorting);
    } else {
      // eslint-disable-next-line max-len
      rowsToConsider = getSortedRows(filterdRows, sortHeader, sortBy, sortDirection, tableData.expandable, enableDateSorting);
    }
    if (tableData.expandable && notEqualCheck(tableData.expandableType, ExpandableType.COMPONENT)) {
      // eslint-disable-next-line no-unused-expressions
      rowsToConsider?.forEach((row, index) => {
        rowsToConsider[index].expandableColumn = getSortedRows(
          row.expandableColumn,
          sortHeader,
          sortBy,
          sortDirection,
          tableData.expandable,
          enableDateSorting
        );
      });
    }
    if (expandableCol === sortBy) {
      // it is ok to assign as this object is used in parent function
      // eslint-disable-next-line no-param-reassign
      tableData.expandableColSortDir = sortDirection;
      // it is ok to assign as this object is used in parent function
      // eslint-disable-next-line no-param-reassign
      tableData.expandableColSortHeader = sortHeader;
    }
  }
  let newRow = [];
  const totalPage = Math.ceil(totalRows / itemsPerPage);
  const currentSelectedPage = currentPage > totalPage ? totalPage : currentPage;
  const startIdx = (currentSelectedPage - 1) * itemsPerPage;
  let endIdx = startIdx + itemsPerPage;
  if (endIdx > filterdRows.length) {
    endIdx = filterdRows.length;
  }
  newRow = rowsToConsider.slice(startIdx, endIdx);
  return newRow;
};

export const getFormattedData = (header, data, hyperlink, tzDbNm) => {
  let formattedData = data;
  if (typeof data === 'string' || header?.type === 'date') {
    const isDate = data?.match(/\d{4}-[01]\d-[0-3]\dT[0-2](?:\d:[0-6]){2}\d/) || data?.match(/\d{4}-[01]\d-[0-3]\d \d{2}:\d{2}:\d{2}/);
    let tmzoneDbNm;
    if (header?.useSystemTimezone === true || tzDbNm === undefined || tzDbNm === null || tzDbNm.length === 0 || tzDbNm === 'NA') {
      tmzoneDbNm = 'America/Phoenix';
    } else {
      tmzoneDbNm = tzDbNm;
    }
    if (isDate) {
      formattedData = convertDateTimeStr(tmzoneDbNm, data, Boolean(typeof header?.includeTime === 'string' ? false : header?.includeTime));
    }
  }
  if (hyperlink === undefined || hyperlink === null) {
    return formattedData || '';
  }
  const shouldWrap = formattedData.length > 30;
  return (
    <Anchor target={header?.openInNewTab ? '_blank' : '_self'} theme={shouldWrap ? { wordBreak: 'break-word' } : { wordBreak: 'normal' }} href={hyperlink}>
      {formattedData}
    </Anchor>
  );
};

export function getTheme(tipType) {
  switch (tipType) {
    case 'error':
      return 'dls-red';
    case 'warning':
      return 'dls-orange';
    default:
      return 'dls-black';
  }
}
export function getBadgeTheme(statusBadge, status) {
  if (statusBadge?.successStatus.includes(status)) {
    return dlsColorSuccessBg;
  } if (statusBadge?.pendingStatus.includes(status)) {
    return dlsOrangeBg;
  } if (statusBadge?.failedStatus.includes(status)) {
    return dlsColorWarningBg;
  } return dlsBlackBg;
}

export function getIcon(tipType) {
  switch (tipType) {
    case 'error':
      return <IconWarning id="error-icon-error" size="sm" theme={dlsRed} filled={true} />;
    case 'warning':
      return <IconWarning id="error-icon-warning" size="sm" theme={dlsOrange} filled={true} />;
    default:
      return <TooltipButton info={true} icon={<GlyphInfo id="icon-info" theme={dlsBlack} />} />;
  }
}
export function formatCellData(header, data, hyperlink, tzDbNm, parseList = true, row) {
  const conditionalFunc = header?.checkCondition;

  let warningData = { toolTipType: undefined, toolTipMessage: undefined };
  if (conditionalFunc !== undefined) {
    warningData = conditionalFunc(data, row);
  }
  const statusBadge = {
    successStatus: undefined,
    pendingStatus: undefined,
    failedStatus: undefined,
  };
  if (header?.statusBadge) {
    statusBadge.successStatus = header.statusBadge.successStatus.map((value) => value.toUpperCase());
    statusBadge.pendingStatus = header.statusBadge.pendingStatus.map((value) => value.toUpperCase());
    statusBadge.failedStatus = header.statusBadge.failedStatus.map((value) => value.toUpperCase());
  }
  if (
    typeof statusBadge !== 'undefined'
      && statusBadge?.successStatus !== undefined
      && statusBadge?.pendingStatus !== undefined
      && statusBadge?.failedStatus !== undefined
      && typeof data !== 'undefined'
      && data !== null
  ) {
    return (
      <div className="flex flex-align-center flex-justify-center">
        <Badge type="text" theme={{ ...getBadgeTheme(statusBadge, data.toUpperCase()), minWidth: 'fit-content', minHeight: 'fit-content' }}>
          {getFormattedData(header, data, null, tzDbNm)}
        </Badge>
        <div style={{ marginRight: '0.25rem' }} />
        {row?.tooltipMsg && (
        <Tooltip
          id="tooltip-info-right"
          triggerElement={
            <TooltipButton info={true} icon={<GlyphInfo />} />
            }
          placement="top"
          info={true}
        >
          {row?.tooltipMsg}
        </Tooltip>
            )}
      </div>
    );
  }
  if (
    typeof header?.delimiter !== 'undefined'
    && typeof data !== 'undefined'
    && data !== null
    && parseList
  ) {
    const dataArr = data.split(header?.delimiter);
    const firstElement = dataArr.shift();
    if (dataArr.length >= 1) {
      return (
        <>
          {getFormattedData(header, firstElement, null, tzDbNm)}
          <Tooltip
            id="cell-data-tooltip"
            placement="bottom"
            info={true}
            triggerElement={(
              <div>
                <span css={styleObj['.plusMore']}> {` +${dataArr.length}`}</span>
              </div>
                )}
          >
            {dataArr.map((d) => getFormattedData(header, d, null, tzDbNm))
              .join(', ')}
          </Tooltip>
        </>
      );
    }
  }
  if (
    typeof warningData !== 'undefined'
        && warningData?.toolTipType !== undefined
        && warningData?.toolTipMessage !== undefined
        && typeof data !== 'undefined'
        && data !== null
  ) {
    return (
      <div className="flex flex-align-center">
        <div className={getTheme(warningData.toolTipType)}>
          {getFormattedData(header, data, null, tzDbNm)}
        </div>
        <Tooltip
          id="cell-data-tooltip"
          placement="bottom"
          className="margin-1-l"
          info={true}
          triggerElement={(
           getIcon(warningData.toolTipType)
            )}
        >
          {warningData.toolTipMessage}
        </Tooltip>
      </div>
    );
  }
  //   // Optional chaining to prevent Ui break
  //   return getFormattedData(header, firstElement, hyperlink?.[header?.id], tzDbNm);
  // }
  return getFormattedData(header, data, hyperlink?.[header?.id], tzDbNm);
}

export function getDefaultColumn(
  hasDefaultColumn,
  tableNm,
  row,
  index,
  rowKeyCol,
  disableRow,
  handleToggleChange,
  getCellId
) {
  if (hasDefaultColumn) {
    return (
      <DataTableCellV2
        id={getCellId(undefined, row, 'toggle')}
        key={getCellId(undefined, row, 'toggle')}
      >
        <div id={`${tableNm}-div-${index}-toggleSwitch`}>
          <ToggleSwitch
            onClick={(e) => handleToggleChange(e, {
              id: row[rowKeyCol],
              toggle: row.default,
            })}
            id={`${tableNm}-toggle-${index}`}
            checked={row.default}
          />
        </div>
      </DataTableCellV2>
    );
  }
  return <></>;
}

export const getRows = (
  loginData,
  tableData,
  isEmpty,
  rows,
  handleRowCheckChange,
  disableCheckbox,
  handleToggleChange,
  handleActionItemClicked
) => {
  const {
    showFilter,
    showError,
    showLoader,
    headers,
    rowKeyCol,
    checkable,
    singleRowSelect,
    inlineItemAction = false,
    singleAction = false,
    actionData = {
      id: 'select',
      label: 'Select',
    },
    tableNm,
    defaultColumn,
    hyperlinkData,
  } = tableData;
  const { timeZoneLocation: tzDbNm } = loginData?.userDetail?.timeZone || {};
  const markup = [];
  const { hasDefaultColumn } = defaultColumn;

  const getEmptyCell = (index) => {
    if (tableData.expandable) return <></>;
    return <DataTableCellV2 id={`${tableNm}-cell-${index}-empty`} />;
  };

  const getCellId = (header, row, str) => `${tableNm}-cell${header ? `-${header?.id}` : ''}${str ? `-${str}` : ''}-${row[rowKeyCol]}`;
  const getCell = (row, header, index, isForExpandableTable, expandableType, hyperlink, tzDbNm1) => {
    // eslint-disable-next-line no-param-reassign
    row = isForExpandableTable && notEqualCheck(expandableType, ExpandableType.COMPONENT)
      ? row.columns
      : row;
    return (
      <DataTableCellV2
        id={getCellId(header, row)}
        key={getCellId(header, row)}
        css={styleObj['.expandableCell']}
      >
        {formatCellData(header, row[header?.id], getHyperlink(hyperlink, row, tableData.rowKeyCol, row),
          tzDbNm1, true, row)}
      </DataTableCellV2>
    );
  };

  // eslint-disable-next-line no-shadow,max-params
  const getExpandableRows = (loginData, row, headers, index, isForExpandableTable, tableData) => {
    // eslint-disable-next-line no-shadow
    const markup = [];

    if (isForExpandableTable) {
      if (tableData.expandableType === 'Component' && tableData.expandableComponent) {
        const ExpandableComponent = tableData.expandableComponent;
        markup.push(
          <DataTableExpandableContentV2 style={{ borderBottom: 'none' }}>
            <ExpandableComponent
              loginData={loginData}
              row={row}
              headers={headers}
              index={index}
              isForExpandableTable={isForExpandableTable}
              tableData={tableData}
              props={tableData.expandableComponentProps}
            />
          </DataTableExpandableContentV2>
        );
      } else {
        row.expandableColumn.forEach((expRow) => {
          markup.push(
            <DataTableExpandableContentV2 style={{
              borderBottom: 'none',
              display: 'contents',
            }}
            >
              <DataTableCellV2
                id={`${tableNm}-cell-exp-empty-${index}`}
                key={`${tableNm}-cell-exp-empty-${index}`}
                css={styleObj['.expandableEmptyCell']}
              />
              {headers
                ?.filter((h) => h?.display === true)
                .map((header) => getCell(
                  expRow,
                  header,
                  index,
                  false,
                  null,
                  getHyperlink(hyperlinkData, expRow, tableData.rowKeyCol), tzDbNm
                )
                )}
            </DataTableExpandableContentV2>
          );
        });
      }
    }
    return markup;
  };

  if (showError) {
    markup.push(<ErrorRow> </ErrorRow>);
  }

  if (markup.length === 0 && showLoader) {
    markup.push(<LoaderRow> </LoaderRow>);
  }

  if (markup.length === 0 && isEmpty) {
    markup.push(<EmptyRow> </EmptyRow>);
  }

  if (markup.length === 0) {
    const newRow = rows;
    if (checkable && singleRowSelect) {
      const label = '';
      // eslint-disable-next-line array-callback-return
      newRow.map((row, index) => {
        let disableRow = false;
        let disableRowIfCbDisable = true;
        if (
          tableData.disableRowIfCbDisable !== null
          && tableData.disableRowIfCbDisable !== undefined
        ) {
          disableRowIfCbDisable = tableData.disableRowIfCbDisable;
        }
        if (typeof disableCheckbox === 'function') {
          disableRow = disableCheckbox(row);
        }
        if (inlineItemAction) {
          const { showActions = true } = row;
          markup.push(
            <DataTableRowV2
              key={row[rowKeyCol]}
              id={row[rowKeyCol]}
              expanded={row.expandable}
              rowIndex={`${index}${row.selected ? '-selected' : ''}`}
              disabled={disableRow ? disableRowIfCbDisable : disableRow}
              theme={disableRow ? tableStyleObject?.disabledCheckboxRow : {}}
            >
              {headers
                ?.filter((h) => h?.display === true)
                ?.map((header) => (
                  <DataTableCellV2
                    css={styleObj['.word_Break']}
                    id={getCellId(header, row)}
                    key={getCellId(header, row)}
                  >
                    {formatCellData(
                      header,
                      row[header?.id],
                      getHyperlink(hyperlinkData, row, tableData.rowKeyCol),
                      tzDbNm,
                      true,
                      row
                    )}
                  </DataTableCellV2>
                ))}

              <DataTableCellV2
                id={getCellId(undefined, row, 'radio')}
                key={getCellId(undefined, row, 'radio')}
              >

                {singleAction ? (
                  <ButtonTertiary
                    size="sm"
                    theme={{
                      '&:hover': { background: 'none !important' },
                      '&:active': { background: 'none !important' },
                      '&:focus': { outline: 'none !important' },
                    }}
                    onClick={() => handleActionItemClicked(actionData.id, [row])}
                  >
                    {actionData.label}
                  </ButtonTertiary>
                ) : (
                  <EnhancedTableRowItemActionList
                    row={row}
                    rowKeyCol={rowKeyCol}
                    handleActionItemClicked={handleActionItemClicked}
                    handleRowCheckChange={handleRowCheckChange}
                    isDisabled={!showActions}
                  />
                )}

              </DataTableCellV2>
              {getExpandableRows(loginData, row, headers, index, tableData.expandable, tableData)}
              {getDefaultColumn(
                hasDefaultColumn,
                tableNm,
                row,
                index,
                rowKeyCol,
                disableRow,
                handleToggleChange,
                getCellId
              )}
            </DataTableRowV2>
          );
        } else {
          markup.push(
            <DataTableRowV2
              key={row[rowKeyCol]}
              id={row[rowKeyCol]}
              rowIndex={`${index}${row.selected ? '-selected' : ''}`}
              disabled={disableRow ? disableRowIfCbDisable : disableRow}
              theme={disableRow ? tableStyleObject?.disabledCheckboxRow : {}}
            >
              <DataTableCellV2
                id={getCellId(undefined, row, 'radio')}
                key={getCellId(undefined, row, 'radio')}
                css={styleObj['.word_Break']}
              >
                <div css={styleObj['.singleradio']}>
                  <input
                    theme={{ position: 'absolute !important' }}
                    css={inputStyle}
                    id={getCellId(undefined, row, 'radio-button')}
                    type="radio"
                    value={index}
                    checked={row.selected}
                    name="sRow"
                    disabled={disableRow}
                    onClick={
                      (e) => handleRowCheckChange(e, {
                        id: row[rowKeyCol],
                        checked: row.selected,
                      })
                    }
                    onChange={
                      (e) => handleRowCheckChange(e, {
                        id: row[rowKeyCol],
                        checked: row.selected,
                      })
                    }
                  />
                  <label
                    id={getCellId(undefined, row, 'radio-label')}
                    css={labelStyle}
                    htmlFor={getCellId(undefined, row, 'radio-button')}
                  >
                    {label}
                  </label>
                </div>
              </DataTableCellV2>
              {headers
                ?.filter((h) => h?.display === true)
                ?.map((header) => (
                  <DataTableCellV2
                    css={styleObj['.word_Break']}
                    id={getCellId(header, row)}
                    key={getCellId(header, row)}
                  >
                    {formatCellData(
                      header,
                      row[header?.id],
                      getHyperlink(hyperlinkData, row, tableData.rowKeyCol),
                      tzDbNm,
                      true,
                      row
                    )}
                  </DataTableCellV2>
                ))}
              {getDefaultColumn(
                hasDefaultColumn,
                tableNm,
                row,
                index,
                rowKeyCol,
                disableRow,
                handleToggleChange,
                getCellId
              )}
            </DataTableRowV2>
          );
        }
      });
    } else if (showFilter && !checkable) {
      // eslint-disable-next-line array-callback-return
      newRow.map((row, index) => {
        const rowIdf = tableData.expandable
        && notEqualCheck(tableData.expandableType, ExpandableType.COMPONENT)
          ? row.columns
          : row;
        let disableRow = false;
        let disableRowIfCbDisable = true;
        if (
          tableData.disableRowIfCbDisable !== null
          && tableData.disableRowIfCbDisable !== undefined
        ) {
          disableRowIfCbDisable = tableData.disableRowIfCbDisable;
        }
        if (typeof disableCheckbox === 'function') {
          disableRow = disableCheckbox(row);
        }
        markup.push(
          <DataTableRowV2
            key={rowIdf[rowKeyCol]}
            id={rowIdf[rowKeyCol]}
            rowIndex={`${index}${row.selected ? '-selected' : ''}`}
            checked={row.selected}
            expanded={row.expandable}
            disabled={disableRow ? disableRowIfCbDisable : disableRow}
            theme={disableRow ? tableStyleObject?.disabledCheckboxRow : {}}
          >
            {getEmptyCell(index)}

            {headers
              ?.filter((h) => h?.display === true)
              .map((header) => getCell(
                row,
                header,
                index,
                tableData.expandable,
                tableData.expandableType,
                hyperlinkData, tzDbNm
              )
              )}

            {getExpandableRows(loginData, row, headers, index, tableData.expandable, tableData)}
            {getDefaultColumn(
              hasDefaultColumn,
              tableNm,
              row,
              index,
              rowKeyCol,
              disableRow,
              handleToggleChange,
              getCellId
            )}
          </DataTableRowV2>
        );
      });
    } else {
      // eslint-disable-next-line array-callback-return
      newRow.map((row, index) => {
        const rowIdf = tableData.expandable
        && notEqualCheck(tableData.expandableType, ExpandableType.COMPONENT)
          ? row.columns
          : row;
        let disableRowIfCbDisable = true;
        if (
          tableData.disableRowIfCbDisable !== null
          && tableData.disableRowIfCbDisable !== undefined
        ) {
          disableRowIfCbDisable = tableData.disableRowIfCbDisable;
        }
        let disableRow = false;
        if (typeof disableCheckbox === 'function') {
          disableRow = disableCheckbox(row);
        }
        markup.push(
          <DataTableRowV2
            key={rowIdf[rowKeyCol]}
            id={rowIdf[rowKeyCol]}
            rowIndex={`${index}${row.selected ? '-selected' : ''}`}
            checked={disableRow ? false : row.selected}
            disabled={disableRow ? disableRowIfCbDisable : disableRow}
            theme={disableRow ? tableStyleObject?.disabledCheckboxRow : {}}
            expanded={row.expandable}
          >
            {headers
              ?.filter((h) => h?.display === true)
              .map((header) => getCell(
                row,
                header,
                index,
                tableData.expandable,
                tableData.expandableType,
                hyperlinkData, tzDbNm
              )
              )}
            {getExpandableRows(loginData, row, headers, index, tableData.expandable, tableData)}
            {getDefaultColumn(
              hasDefaultColumn,
              tableNm,
              row,
              index,
              rowKeyCol,
              disableRow,
              handleToggleChange,
              getCellId
            )}
          </DataTableRowV2>
        );
      });
    }
  }

  return markup;
};

const EmptyRow = () => {
  const context = useEnhancedDataTableContext();
  const { emptyDataMsg } = context;
  return (
    <DataTableRowV2 id="emptyRow" key="emptyRow">
      <DataTableCellV2 id="emptyMessageRow" colSpan="12" key="emptyRow">
        <div className="flex flex-align-center flex-justify-center">{emptyDataMsg}</div>
      </DataTableCellV2>
    </DataTableRowV2>
  );
};

const ErrorRow = () => {
  const context = useEnhancedDataTableContext();
  const { errMsg } = context;
  return (
    <DataTableRowV2 id="errorRow" key="errorRow">
      <DataTableCellV2 id="errorMessageRow" colSpan="12" key="errorRow">
        <div className="flex flex-align-center flex-justify-center">
          <Alert>{errMsg}</Alert>
        </div>
      </DataTableCellV2>
    </DataTableRowV2>
  );
};

const LoaderRow = () => (
  <DataTableRowV2 id="loadRow" key="loadRow">
    <DataTableCellV2 id="loadMessageRow" colSpan="12" key="loadMessageRow">
      <div className="flex flex-align-center flex-justify-center">
        <ProgressCircle size="lg" />
      </div>
    </DataTableCellV2>
  </DataTableRowV2>
);
